import { useQuery } from '@tanstack/react-query';
import { ProductFilter } from '../../../models/Product';
import { Pagination } from '../../../models/Pagination';
import { fetchBundleDetailProducts } from './fetchBundleDetailProducts';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';

type Props = {
    bundleId: string;
    filterMap: ProductFilter;
    pagination: Pagination;
};

const BUNDLE_DETAIL_KEY = 'bundleDetailProducts';

export const useBundleDetailProducts = ({ bundleId, pagination, filterMap }: Props) => {
    const transformedFilterMap = JSON.stringify(filterMap);

    return useQuery(
        [BUNDLE_DETAIL_KEY, bundleId, { filterMap: transformedFilterMap, ...pagination }],
        () => fetchBundleDetailProducts({ bundleId, pagination, filterMap: transformedFilterMap }),
        { ...GlobalReactQueryOptions }
    );
};

export const invalidateBundleDetailProducts = (bundleId: string) => {
    return browserClient.invalidateQueries([BUNDLE_DETAIL_KEY, bundleId]);
};
